"use client";

import React from "react";
import { ArrowLeft, Clock, MapPin, Phone, ShieldCheck } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const guarantees = [{
  icon: Clock,
  label: "24/7 Emergency Dispatch"
}, {
  icon: MapPin,
  label: "Fast Forest Park Arrival"
}, {
  icon: ShieldCheck,
  label: "Licensed & Insured Pros"
}];
export default function Closingcta() {
  const prefersReducedMotion = useReducedMotion();
  const animationProps = prefersReducedMotion ? {
    initial: {
      opacity: 1,
      y: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  };
  return <section id="closingcta" data-nav="light" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <motion.div {...animationProps} className="bg-card text-card-foreground border border-border rounded-2xl p-8 md:p-12 shadow-lg text-center relative overflow-hidden">
          {/* Decorative background ambient accent */}
          <div className="absolute -top-24 -right-24 w-72 h-72 bg-accent/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-primary/10 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 flex flex-col items-center">
            <Badge variant="secondary" className="mb-4 gap-1.5 px-3 py-1 font-semibold text-xs tracking-wide">
              <MapPin className="size-3.5 text-accent-foreground" />
              Forest Park Service Area
            </Badge>

            <h2 className="font-default text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground max-w-3xl leading-tight">
              Need Plumbing Service in Forest Park? Contact Us Today
            </h2>

            <p className="mt-4 text-muted-foreground text-base sm:text-lg max-w-2xl leading-relaxed">
              Our experienced local plumbers are on standby 24 hours a day to handle emergency pipe leaks, clogged drains, water heater repairs, and full plumbing inspections.
            </p>

            {/* Quick trust metrics */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 my-8 w-full max-w-2xl">
              {guarantees.map((item, i) => {
              const IconComponent = item.icon;
              return <div key={item.label} data-index={i} className="flex items-center justify-center gap-2 py-2.5 px-3 bg-muted/60 rounded-lg text-xs sm:text-sm font-medium text-foreground border border-border/50">
                    <IconComponent className="size-4 text-primary shrink-0" />
                    <span>{item.label}</span>
                  </div>;
            })}
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full max-w-md">
              <Button asChild size="lg" className="w-full sm:w-auto flex-1 font-semibold text-base shadow-md h-12">
                <a href="tel:4708479076">
                  <Phone className="size-5" />
                  Call (470) 847-9076
                </a>
              </Button>

              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto flex-1 font-semibold text-base h-12">
                <Link to="/contact/">Request Service Online</Link>
              </Button>
            </div>

            {/* Hub Navigation Link */}
            <div className="mt-8 pt-6 border-t border-border/70 w-full flex justify-center">
              <Link to="/service-areas/" className="inline-flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground transition-colors">
                <ArrowLeft className="size-4" />
                <span>Back to All Service Areas</span>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}